export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DAYS_OF_THE_WEEK = [
  {
    id: 'sun',
    short: 'sun',
    full: 'sunday',
  },
  {
    id: 'mon',
    short: 'mon',
    full: 'monday',
  },
  {
    id: 'tue',
    short: 'tue',
    full: 'tuesday',
  },
  {
    id: 'wed',
    short: 'wed',
    full: 'wednesday',
  },
  {
    id: 'thur',
    short: 'thur',
    full: 'thursday',
  },
  {
    id: 'fri',
    short: 'fri',
    full: 'friday',
  },
  {
    id: 'sat',
    short: 'sat',
    full: 'saturday',
  },
];
